import type { ReactNode } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface ChartExpandModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Width override for charts whose expanded form needs more room than the
   * default (e.g. "Documents by", which shows three donuts with full legends). */
  contentClassName?: string;
  children: ReactNode;
}

export function ChartExpandModal({
  open,
  onOpenChange,
  title,
  contentClassName = "max-w-3xl",
  children,
}: ChartExpandModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* Cap the dialog at the viewport and scroll the body, so expanded
          content is never clipped by the modal edge however tall it gets. */}
      <DialogContent className={`max-h-[90vh] grid-rows-[auto_minmax(0,1fr)] ${contentClassName}`}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="overflow-y-auto py-4">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
